import type { CssSpaceValue, } from "@bracket/ui/types";
import styled from "styled-components";

export declare type SvgProps = React.SVGProps<SVGSVGElement> & {
	$width?: CssSpaceValue;
	$height?: CssSpaceValue;
	$flexible?: boolean;
	$debug?: boolean;
}

export const Svg = styled.svg<SvgProps>`
	display: flex;
	box-sizing: border-box;
	user-select: none;
	width: ${({ $width }) => $width !== undefined ? $width : "100%;"};
	height: ${({ $height }) => $height !== undefined ? $height : "100%;"};
	${({ $flexible }) => $flexible !== undefined ? "flex: 1;" : ""}
	${({ $debug }) => $debug === true ? "border: 1px solid red;" : ""}
`;

export declare type GroupProps = React.SVGProps<SVGGElement> & { $debug?: boolean; left?: number; top?: number; }
export const Group = styled.g<GroupProps>`
	${({ $debug }) => $debug === true ? "fill: red!important;" : ""}
`;

export declare type CircleProps = React.SVGProps<SVGCircleElement> & { $debug?: boolean; }
export const Circle = styled.circle<CircleProps>`
	${({ $debug }) => $debug === true ? "stroke: red!important;" : ""}
`;
